import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SagCheckboxGroupComponent } from './sag-checkbox-group.component';
import { SagCheckboxComponent } from './sag-checkbox.component';


@NgModule({
  declarations: [SagCheckboxGroupComponent, SagCheckboxComponent],
  imports: [
    CommonModule,
  ],
  exports: [SagCheckboxGroupComponent, SagCheckboxComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class SagCheckboxGroupModule { }
